import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import styled from "styled-components";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router-dom";

const customStyle = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.85)",
    zIndex: 999999,
    display: "flex",
    justifyContent: "center",
  },
  content: {
    marginTop: "10vh",
    border: "none",
    borderRadius: 4,
    zIndex: 1000000,
    background: "none",
    padding: "none",
    overflow: "unset",
    minHeight: 500,
    minWidth: 400,
    top: "noen",
    bottom: "noen",
    right: "noen",
    left: "noen",
    maxHeight: "80%",
    overflowY: "auto",
  },
};

const Content = styled.div`
  background-color: white;
  min-height: 200px;
  display: flex;
  flex-direction: column;
  padding: 35px 15px;
  padding-bottom: 15px;
  background-color: white;
  border-left: 25px solid ${(p) => p.theme.borders.warning};
`;

const Icon = styled.div`
  font-size: 4rem;
  color: ${(p) => p.theme.altColors.warning};
`;

const Text = styled.div`
  font-family: ${(p) => p.theme.fonts.primary};
  font-size: 1rem;
  color: ${(p) => p.theme.altColors.warning};
  padding-left: 25px;
  padding-right: 25px;
  margin-top: 20px;
`;

const Top = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-left: 25px;
  padding-right: 25px;
`;

const CountDown = styled.div`
  font-weight: 800;
  font-size: 3rem;
  color: ${(p) => p.theme.altColors.warning};
  width: 100%;
  padding-left: 80px;
`;

const Bottom = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  color: ${(p) => p.theme.altColors.warning};
  width: 100%;
  align-items: flex-end;
  margin-top: 25px;
`;

const Button = styled.button`
  padding: 0px 25px;
  border: none;
  background-color: transparent;
  color: ${(p) => p.theme.altColors.warning};
  font-family: ${(p) => p.theme.fonts.primary};

  &:hover {
    opacity: 0.5;
  }
`;

function pad(num) {
  return ("0" + num).slice(-2);
}

function hhmmss(secs) {
  if (secs <= 0) {
    return "Du loggas nu ut...";
  }
  var minutes = Math.floor(secs / 60);
  secs = secs % 60;
  minutes = minutes % 60;
  return `${pad(minutes)}:${pad(secs)}`;
}

export default withRouter(
  injectIntl(
    ({
      confirmLabel = "Stay logged in",
      confirm,
      closeLabel = "Logout",
      idleWarning,
      intl,
      redirectTo = "logout",
      warningText = "Idle.Warning",
    }) => {
      const [timer, setTimer] = useState(0);
      const [timerId, setTimerId] = useState(null);

      useEffect(() => {
        if (!timerId) {
          const id = setInterval(() => setTimer((timer) => timer + 1), 1000);
          setTimerId(id);
        }

        return () => {
          clearInterval(timerId);
        };
      }, []);

      const handleConfirm = () => {
        confirm();
      };

      const handleClose = (timedOut) => {
        localStorage.removeItem("_jwt");
        window.location = `${redirectTo}${timedOut ? "?timedOut=true" : ""}`;
      };

      // watch for timeout values
      useEffect(() => {
        if (timer > idleWarning * 60) {
          handleClose(true);
        }
      }, [timer]);

      return (
        <Modal isOpen={true} style={customStyle}>
          <Content>
            <Top>
              <Icon className="fad fa-clock" />
              <CountDown>{hhmmss(idleWarning * 60 - timer)}</CountDown>
            </Top>
            <Text>
              {warningText && intl.formatMessage({ id: warningText })}
            </Text>
            <Bottom>
              <Button onClick={() => handleClose(false)}>
                {closeLabel && intl.formatMessage({ id: closeLabel })}
              </Button>
              <Button onClick={handleConfirm}>
                {confirmLabel && intl.formatMessage({ id: confirmLabel })}
              </Button>
            </Bottom>
          </Content>
        </Modal>
      );
    }
  )
);
